import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const http = axios.create({
    baseURL: API_URL,
    // headers: {
    //     "Content-type": "application/json",
    // },
    headers: authHeader(),
});

const getAll = () => {
    return http.get("/balance");
};

const create = () => {
    return http.post("/balance");
};

const BalanceService = {
    getAll,
    create,
};

export default BalanceService;
